<template>
	<div class="wrapper">
		<div class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<div>
						<genericTable :table-data="tableData" :filter="true" :fields="fields" :per-page=20 hover striped bordered small
													caption="<i class='icon-list'></i> List of group of companies">
							<template v-slot:actions>
								<b-nav pills small class="float-right" v-if="$store.getters.canWrite">
									<b-nav-item active v-b-modal.company-group-create-modal><i class="fa fa-plus"></i> Add Group of Company</b-nav-item>
								</b-nav>
							</template>
							<template v-slot:row-actions="row">
								<b-button v-if="$store.getters.canWrite" size="sm" variant="danger" class="mr-1" @click="passDataToModal(row)" active v-b-modal.company-group-edit-modal>
									<i class="icon-pencil"></i> Edit
								</b-button>
							</template>
						</genericTable>
					</div>
				</b-col>
			</b-row>
		</div>
		<b-modal id="company-group-create-modal"
						 title="Add New Group of Company"
						 ok-title="Save"
						 @ok="createCompanyGroup"
						 @cancel="resetForm">
			<b-form @submit.prevent="checkFormValidity()" method="post">
				<b-form-group
					label="Name"
					label-for="name"
					:label-cols="3"
					:horizontal="true">
					<b-form-input v-model="form.name" name="name" id="name" type="text" placeholder="Name" :state="$v.form.name.$dirty ? !$v.form.name.$error : null" aria-describedby="name-live-feedback"></b-form-input>
					<b-form-invalid-feedback id="name-live-feedback">This is a required field and must not be blank.</b-form-invalid-feedback>
				</b-form-group>
			</b-form>
		</b-modal>
		<b-modal id="company-group-edit-modal"
						 title="Edit Group of Company"
						 ok-title="Save"
						 @ok="updateCompanyGroup"
						 @cancel="resetEditForm">
			<b-form @submit.prevent="checkEditFormValidity()" method="post">
				<b-form-group
					label="Name"
					label-for="name"
					:label-cols="3"
					:horizontal="true">
					<b-form-input v-model="editForm.name" name="name" id="name" type="text" placeholder="Name"></b-form-input>
				</b-form-group>
			</b-form>
		</b-modal>
	</div>
</template>

<script>
	import genericTable from '@/components/GenericTable';
	import companyGroupService from "@/services/companyGroupService";
	import toastService from "@/services/toastService";
	import {required} from 'vuelidate/lib/validators';

	export default {
		name : "CompanyGroupList",
		components: {
			"genericTable": genericTable
		},
		data: function() {
			return {
				companyGroupList: [],
				companyGroupIdToBeEdited: null,
				form: {
					name: null
				},
				editForm: {
					name: null
				},
				isEditModalVisible: false,
				fields: [
					{key: 'id', label: 'ID', sortable: true, class: 'text-center'},
					{key: 'name', label: 'Name', sortable: true, searchable:true},
					{key: 'actions', label: 'Actions', class: 'text-center'}
				]
			}
		},
		validations: {
			form: {
				name: {
					required
				}
			},
			editForm: {
				name: {

				}
			}
		},
		methods: {
			getAllCompanyGroups: function () {
				companyGroupService.getAllCompanyGroups((data) => {
					this.companyGroupList = data;
				}, (error) => {
					toastService.showErrorToast("Could not fetch group of companies list " + error);
				});
			},
			createCompanyGroup: function (){
				const formData = {
					name: this.form.name,
				};
				companyGroupService.createCompanyGroup(formData, (data) => {
					this.companyGroupList = data;
					this.$nextTick(() => { this.$v.$reset() });
					this.resetForm();
					toastService.showSuccessToast("Group of Company created successfully");
				}, (error) => {
					this.$nextTick(() => { this.$v.$reset() });
					this.resetForm();
					toastService.showErrorToast("Could not create new group of company " + error);
				});
			},
			updateCompanyGroup: function (){
				const editFormData = {
					name: this.editForm.name,
				};
				companyGroupService.updateCompanyGroup(this.companyGroupIdToBeEdited, editFormData, (data) => {
					this.companyGroupList = data;
					this.resetEditForm();
					toastService.showSuccessToast("Group of Company updated successfully");
				}, (error) => {
					this.resetEditForm();
					toastService.showErrorToast("Could not update new group of company " + error);
				});
			},
			resetForm: function (){
				this.form.name = null;
			},
			resetEditForm: function (){
				this.editForm.name = null;
				this.companyGroupIdToBeEdited = null;
			},
			checkFormValidity: function (){
				let formHasErrors = false;

				this.$v.form.$touch();
				if (this.$v.form.$anyError) {
					formHasErrors = true;
				}

				if(formHasErrors) return;
				else this.createCompanyGroup();
			},
			checkEditFormValidity: function (){
				let formHasErrors = false;

				this.$v.editForm.$touch();
				if (this.$v.editForm.$anyError) {
					formHasErrors = true;
				}

				if(formHasErrors) return;
				else this.updateCompanyGroup();
			},
			passDataToModal: function (data){
				this.editForm.name = data.row.item.name;
				this.companyGroupIdToBeEdited = data.row.item.id;
			}
		},
		created() {
			this.getAllCompanyGroups();
		},
		computed: {
			tableData : function(){
				return this.companyGroupList;
			}
		}
	}
</script>

<style scoped>

</style>
